module.exports = {
  sectionSelector: ".mo2022-section[data-title]",
  isWatching: true,

  init() {
    let moheader = document.querySelector('.mo2022_header');
    if (!moheader) return;

    this.applyScrollClass();
    this.checkSections();
    document.addEventListener('scroll', () => {
      this.applyScrollClass();
      this.checkSections();
    })

    let sections = document.querySelectorAll(this.sectionSelector);
    this._createNav(moheader, sections);
  },

  _createNav(moheader, sections) {
    if (moheader && sections.length) {
      let menu = moheader.querySelector('.mo2022_header-menu .nav');
      sections.forEach((elem, ind) => {
        menu.innerHTML += `<li class="nav-item d-inline-block mx-3 ${ ind == 0 ? 'active' : '' }"><button class="nav-link" data-target="#${elem.querySelector('.mo2022-section-anchor').getAttribute('id')}">${elem.getAttribute('data-title')}</button></li>`;
      })
      menu.querySelectorAll('.nav-link').forEach((elem) => {
        elem.addEventListener('click', () => {
          this.isWatching = false;
          this._animateScroll(document.querySelector(elem.getAttribute('data-target'))).then(() => {
            this.isWatching = true;
            this._centerActiveNavItem();
          });
        })
      })
    } else if (moheader && moheader.querySelector('.mo2022_header-menu')) {
      moheader.querySelector('.mo2022_header-menu').remove();
    }
  },

  _animateScroll(elem) {
    return new Promise((resolve, reject) => {
      let same = 0;
      let lastPos = null;
      elem.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start"
      });

      let _checkScrollAnimation = () => {
        const newPos = elem.getBoundingClientRect().top;
        if (newPos == lastPos) {
          if (same ++ > 2) {
            return resolve();
          }
        } else {
          same = 0;
          lastPos = newPos;
        }
        window.requestAnimationFrame(_checkScrollAnimation);
      }
      
      window.requestAnimationFrame(_checkScrollAnimation);
    });
  },

  applyScrollClass() {
    document.querySelector('body').classList.toggle('scroll-at-top', window.scrollY <= 0);
  },

  _getOffsetTop(elem) {
    return elem.offsetTop - elem.scrollTop + (elem.offsetParent ? this._getOffsetTop(elem.offsetParent) : 0);
  },

  _centerActiveNavItem() {
    let sectionNav = document.querySelector('#mo2022-section-nav')
    let elem = sectionNav.querySelector('.active');
    sectionNav.parentElement.scrollLeft = Math.max(0, elem.offsetLeft + elem.offsetWidth / 2 - sectionNav.parentElement.offsetWidth / 2 - sectionNav.offsetLeft);
  },

  checkSections() {
    let lastVisible = null;
    document.querySelectorAll(this.sectionSelector + ' .mo2022-section-anchor').forEach((sectionAnchor) => {
      if (this._getOffsetTop(sectionAnchor) <= window.scrollY + document.querySelector('.mo2022_header').offsetHeight) {
        lastVisible = sectionAnchor;
      }
    });
    document.querySelectorAll('#mo2022-section-nav .nav-item').forEach((elem) => {
      if (lastVisible && elem.querySelector('.nav-link').getAttribute('data-target') == `#${lastVisible.getAttribute('id')}`) {
        let isChange = !elem.classList.contains('active');
        elem.classList.add('active');
        if (isChange && this.isWatching) {
          this._centerActiveNavItem();
        }
      } else {
        elem.classList.remove('active');
      }
    })
  }
};